const urlParams = new URLSearchParams(window.location.search);
const initialQuery = urlParams.get('query') || '';
const QS_INDEX1 = 'wa-shopify_products_query_suggestions';
const suggestionContainer = document.getElementById('did-you-mean');
const isSearchPage = window.location.pathname === '/search';
const isCollectionPage = window.location.pathname === '/collections/all';

// Collection-aware product URLs: carry the current collection into the product
// page URL so Liquid sees the `collection` object (used by the breadcrumb
// override). #col_name is blank outside collection templates -> plain URL.
function productUrl(handle) {
  const colInput = document.querySelector('#col_name');
  const colName = colInput ? colInput.value.trim() : '';
  return colName ? `/collections/${colName}/products/${handle}` : `/products/${handle}`;
}
const WIRE_FACET = 'meta.custom.algolia_filters.wire_size';
const awgRegex   = /\b(\d{1,3})\s*awg\b/i;

let searchPageFilterIgnore = [];
if (isSearchPage) {
  const ignoreField = document.querySelector('#ignore_list')?.value;
  if (ignoreField) {
    searchPageFilterIgnore = ignoreField.split(',').map(val => val.trim().toLowerCase());
  }
}

if(document.querySelector('#chk_template_type').value != 'NOT product_type:Rebate' && document.querySelector('#chk_template_type').value != 'collection'){
  var search = instantsearch({
    indexName: isSearchPage ? "wa-shopify_products_search" : "wa-shopify_products",
    searchClient: algoliasearch('T3ODYTC4CT', 'd86df99f71dbffd2d6ce8b9700d9855c'),
    initialUiState: {
      shopify_products: {
        query: initialQuery,
      },
    },
  });
}else{
  var search = instantsearch({
      indexName: isSearchPage ? "wa-shopify_products_search" : "wa-shopify_products",
      searchClient: algoliasearch('T3ODYTC4CT', 'd86df99f71dbffd2d6ce8b9700d9855c'),
      initialUiState: {
        shopify_products: {
          query: initialQuery,
        },
      },
      searchFunction(helper) {
        const q = helper.state.query || '';
        const m = awgRegex.exec(q);        

        helper.setQueryParameter('facetFilters', []);

        if (m) {
          const size = parseInt(m[1], 10);
          const value = `${size} AWG`;
          const ff = [[`${WIRE_FACET}:${value}`]];

          helper
            .setQueryParameter('facetFilters', ff)
            .setQueryParameter('advancedSyntax', true)
            .setQueryParameter('queryType', 'prefixNone')
            .setQueryParameter('typoTolerance', 'min')
            .setQueryParameter('enableRules', true)
            .setQueryParameter('ruleContexts', ['merchandising']);
        } else {
          helper
            .setQueryParameter('advancedSyntax', false)
            .setQueryParameter('queryType', 'prefixAll')
            .setQueryParameter('typoTolerance', 'true')
            .setQueryParameter('enableRules', true)
            .setQueryParameter('ruleContexts', ['merchandising']);
        }

        helper
          .setQueryParameter('hitsPerPage', 200)
          .search();
      },
  });
}

  const searchClient = algoliasearch(
    "T3ODYTC4CT",
    "d86df99f71dbffd2d6ce8b9700d9855c"
  );

  const qsClient = algoliasearch(
    "T3ODYTC4CT",
    "d86df99f71dbffd2d6ce8b9700d9855c"
  ).initIndex(QS_INDEX1);

  const {
    refinementList,
    dynamicWidgets,
    menu,
    hierarchicalMenu,
    searchBox,
    hits,
    pagination,
    configure,
    currentRefinements,
    clearRefinements,
  } = instantsearch.widgets;

  const {
    connectSortBy,
    connectSearchBox,
    connectStats,
    connectRange,
    connectCurrentRefinements,
  } = instantsearch.connectors;

  
  const facetsWrapper = document.querySelector('.facets-warpper');
  const sideFilterWrapper = document.querySelector('.filter-wrapper-inner');

  let colTopFilters = {};
  let shopTopFilters = {};

  try {
    const colInput = document.querySelector("#col_tf")?.value;
    if (colInput && colInput != null) colTopFilters = JSON.parse(colInput);
  } catch (e) {
    console.warn("Invalid JSON in col_tf:", e);
  }

  try {
    const shopInput = document.querySelector("#shop_tf")?.value;
    if (shopInput && shopInput != null && !isCollection()) shopTopFilters = JSON.parse(shopInput);
  } catch (e) {
    console.warn("Invalid JSON in shop_tf:", e);
  }

  let activeFilters = (colTopFilters != null && Object.keys(colTopFilters).length) ? colTopFilters : shopTopFilters;
  // const TOP_FILTERS = Object.entries(activeFilters).map(([key, label]) => ({
  //   label,
  //   attribute: `meta.custom.algolia_filters.${key}`
  // }));

  const TOP_FILTERS = Object.entries(activeFilters || {}).flatMap(([key, label]) => {
    const attr = key.toLowerCase();
    if (attr === 'color') {
      return [
        { label, attribute: 'options.color' }
      ];
    } else {
      return [{ label, attribute: `meta.custom.algolia_filters.${key}` }];
    }
  });

  
  // const TOP_FILTERS = [
  //   {
  //     label: 'Conductor Material',
  //     attribute: 'meta.custom.algolia_filters.conductor_material'
  //   },
  //   {
  //     label: 'AWG Size',
  //     attribute: 'meta.custom.algolia_filters.awg_size'
  //   },
  //   {
  //     label: 'Color',
  //     attribute: 'meta.custom.algolia_filters.color'
  //   },
  //   {
  //     label: 'Amps',
  //     attribute: 'meta.custom.algolia_filters.amps'
  //   }
  // ];

  function isCollection(){
    const colName = document.querySelector("#col_name").value;
    return (colName == "" || colName == null || colName == undefined) ? false : true;
  }
  
  // Function to check if a filter has selected values
  function hasFilterSelected(filterAttribute) {
    const state = search.helper.state;
    return state.isFacetRefined(filterAttribute) || 
           state.isDisjunctiveFacetRefined(filterAttribute) ||
           state.getFacetRefinements(filterAttribute).length > 0;
  }
  
  // Function to update filter UI based on selection state
  function updateFilterUI(filterContainer, filterAttribute) {
    // console.log('in updateUI',filterContainer,filterAttribute);
    // Add checks for search and search.helper
    if (!search || !search.helper || !search.helper.state) {
      console.warn('Algolia search helper or state not available yet.');
      return;
    }

    const summary = filterContainer.querySelector('summary');
    const allText = summary.querySelector('.facets__summary-title');
    const clearBtn = filterContainer.querySelector('.clear-filter');
    
    // Get the selected refinements for this attribute
    const selectedValues = search.helper.state.disjunctiveFacetsRefinements[filterAttribute] || [];
    // console.log(selectedValues.length,'selectedValues.length',filterContainer,filterAttribute);

    if (filterContainer.querySelectorAll('input[checked]').length || selectedValues.length > 0) {
      filterContainer.classList.add('has-selection');
      let selectedText;
      if (selectedValues.length === 1) {
        selectedText = selectedValues[0];
      } else {
        selectedText = `${selectedValues[0]} (+${selectedValues.length - 1})`;
      }

      if (clearBtn) {
        clearBtn.removeAttribute('disabled');
      }
    } else {
      allText.textContent = 'All';
      filterContainer.classList.remove('has-selection');  
      if (clearBtn) {
        clearBtn.setAttribute('disabled', 'disabled');
      }
    }
  }
  
  TOP_FILTERS.forEach((filter, index) => {
    if (isSearchPage) return;

    if(document.querySelector('#col_top_filter') && document.querySelector('#col_top_filter').value != ''){
      var curr_filter = filter.label.toLocaleLowerCase().replaceAll(' ','-');
      var side_filter_ignor = document.querySelector('#col_top_filter').value.toLocaleLowerCase().replaceAll(' ','-').split(',');
      // console.log(side_filter_ignor.includes(curr_filter),'chk');
      if(side_filter_ignor.includes(curr_filter)){
        return;
      }
    }
    const filterContainer = document.createElement('details');
    filterContainer.className = 'disclosure-has-popup facets__custom-dropdown facets__disclosure js-filter';
    filterContainer.setAttribute('data-index', index);
    filterContainer.id = `Details-top-${index}`;
  
    filterContainer.innerHTML = `
      <summary class="facets__summary focus-inset" role="button" aria-expanded="false" aria-controls="Facet-${index}">
        <label class="h6 re-le-sp-2">${filter.label}</label>
        <div class="facets__summary-inner">
          <div class="facets__summary-title">All</div>
          <div class="facets__summary-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="icon icon-arrow-down">
              <path d="M13.1016 5.5L8.10156 10.5L3.10156 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </div>
        </div>
      </summary>
      <div id="Facet-${index}" class="facets__display">
        <ul class="facets__list list-unstyled" role="list" id="facet-list-${index}"></ul>
        <div class="button-group">
          <button class="button button--secondary re-le-sp-1 clear-filter" data-attribute="${filter.attribute}" disabled>Clear All</button>
          <button class="button button--primary re-le-sp-1 apply-filter" data-attribute="${filter.attribute}">Apply</button>
        </div>
      </div>
    `;
    facetsWrapper.appendChild(filterContainer);

    
  
    let pendingRefinements = new Set();
  
    search.addWidgets([
      instantsearch.connectors.connectRefinementList((renderOptions, isFirstRender) => {
        const {
          items,
          refine,
          widgetParams
        } = renderOptions;

        let sortedItems = items;
        if(widgetParams.attribute != "meta.custom.algolia_filters.wire_size"){
          sortedItems = [...items].sort((a, b) =>
            a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' })
          );
        }

        const listEl = document.querySelector(`#facet-list-${index}`);
        listEl.innerHTML = '';
  
        sortedItems.forEach(item => {
          const li = document.createElement('li');
          li.className = 'list-menu__item facets__item field--checkbox';
          const inputId = `facet-${index}-${item.label.replace(/\s+/g, '-')}`;
  
          li.innerHTML = `
            <input type="checkbox" class="focus-inset" value="${item.value}" id="${inputId}" ${item.isRefined ? 'checked' : ''}>
            <label for="${inputId}" class="facet-checkbox re-le-sp-1">
              <span class="icon icon-checkmark"></span>
              <span class="facet-checkbox__label">${item.label}</span>
            </label>
          `;
  
          const checkbox = li.querySelector('input');
  
          checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
              pendingRefinements.add(item.value);
            } else {
              pendingRefinements.delete(item.value);
            }
            // Update UI after checkbox change
            //updateFilterUI(filterContainer, filter.attribute);
          });
  
          listEl.appendChild(li);
        });

        if(items.length == 0){
          filterContainer.classList.add('hidden');
        }else{
          filterContainer.classList.remove('hidden');
        }
  
        const applyBtn = document.querySelector(`#Facet-${index} .apply-filter`);
        const clearBtn = document.querySelector(`#Facet-${index} .clear-filter`);
  
        if (applyBtn) {
          applyBtn.onclick = () => {
            items.forEach(item => {
              const shouldBeRefined = pendingRefinements.has(item.value);
              if (item.isRefined && !shouldBeRefined) refine(item.value);
              if (!item.isRefined && shouldBeRefined) refine(item.value);
            });

            // Get the selected values after applying
            const selectedValues = Array.from(pendingRefinements);
            const summaryTitle = filterContainer.querySelector('.facets__summary-title');
            const clearBtn = filterContainer.querySelector('.button--secondary.clear-filter');
            
            if (selectedValues.length > 0) {
              if (selectedValues.length === 1) {
                summaryTitle.textContent = selectedValues[0];
              } else {
                summaryTitle.textContent = `${selectedValues[0]} (+${selectedValues.length - 1})`;
              }
              // Enable clear button when filters are selected
              if (clearBtn) {
                clearBtn.removeAttribute('disabled');
                clearBtn.classList.remove('disabled');
              }
            } else {
              summaryTitle.textContent = 'All';
              // Disable clear button when no filters are selected
              if (clearBtn) {
                clearBtn.setAttribute('disabled', 'disabled');
                clearBtn.classList.add('disabled');
              }
            }

            applyBtn.closest('details').querySelector('summary').click();
          };
        }
  
        if (clearBtn) {
          clearBtn.onclick = () => {
            items.forEach(item => {
              if (item.isRefined) refine(item.value);
            });
            pendingRefinements.clear();
            const checkboxes = listEl.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
              checkbox.checked = false;
            });
            // Update UI after clearing filters
            const summaryTitle = filterContainer.querySelector('.facets__summary-title');
            summaryTitle.textContent = 'All';
            clearBtn.setAttribute('disabled', 'disabled');
            clearBtn.classList.add('disabled');
            clearBtn.closest('details').querySelector('summary').click();
          };
        }
  
        // Initial UI update
        if (!isFirstRender) {
          //updateFilterUI(filterContainer, filter.attribute);
        }
  
      })({
        container: `#facet-list-${index}`,
        attribute: filter.attribute,
        limit: 100
      })
    ]);
  });
  
  // const SIDE_FILTERS = [
  //   {
  //     label: 'Conductor Type',
  //     attribute: 'meta.custom.algolia_filters.conductor_type'
  //   },
  //   {
  //     label: 'Stranding',
  //     attribute: 'meta.custom.algolia_filters.stranding'
  //   },
  //   {
  //     label: 'OD',
  //     attribute: 'meta.custom.algolia_filters.od'
  //   },
  //   {
  //     label: 'Temp Rating',
  //     attribute: 'meta.custom.algolia_filters.temp_rating'
  //   }
  // ];

  let shopSideFilters = {};
  let colSideFilters = {};

  try {
    const sideInput = document.querySelector("#col_sf")?.value;
    if (sideInput) colSideFilters = JSON.parse(sideInput);
  } catch (e) {
    console.warn("Invalid JSON in shop_sf:", e);
  }

  try {
    const topInput = document.querySelector("#shop_sf")?.value;
    if (topInput && !isCollection()) shopSideFilters = JSON.parse(topInput);
  } catch (e) {
    console.warn("Invalid JSON in shop_tf:", e);
  }

  const ORDER = [
    'Wire Size','Conductor Count','Conductor Material','Conductor Type','Amp Rating',
    'Shield Coverage','Shield Type','Outer Diameter','Grouping','Manufacturer',
    'Insulation Type','Jacket Type','Direct Burial','Other Certifications','ROHS Compliant',
    'Flexibility','Strand Count','Common Uses','Primary Applications','Shortdescription',
    'Description Tag','Title Tag'
  ];

  const HIDE = [
    'Secondary Vendors','Vendors','Single Line Text Field','Misc Info.','Featured Specs',
    'Video Detail','Video Title','Video Subtitle','Video URL','Jacket Thickness','Minimum Order Length', 'single_line_text_field_', 'Parentsku'
  ];

  let SIDE_FILTERS = [];
  const activeSideFilters = (colSideFilters != null && Object.keys(colSideFilters).length) ? colSideFilters : shopSideFilters;
  if(isSearchPage || isCollectionPage){
    const index = searchClient.initIndex(isSearchPage ? "wa-shopify_products_search" : "wa-shopify_products");
    index
      .search(initialQuery, {
        facets: ['*'],
        hitsPerPage: 0
      })
      .then(res => {
        const facets = res.facets || {};        
        let sideFacetKeys = Object.keys(facets).filter(facet =>
          facet.startsWith('meta.custom.algolia_filters.')
        );        

        const norm = s => (s ?? "").toString().trim().toLowerCase().replaceAll(" ", "_").replaceAll("meta.custom.algolia_filters.", "");
        const ORDER_POS = Object.fromEntries(ORDER.map((label, i) => [norm(label), i]));
        const HIDE_SET  = new Set(HIDE.map(norm));
        const visible = sideFacetKeys.filter(item => !HIDE_SET.has(norm(item)));
        const inOrder = [];
        const others  = [];

        for (const item of visible) {
          const key = norm(item);
          const pos = ORDER_POS[key];
          if (pos !== undefined) {
            inOrder.push({ item, ord: pos });
          } else {
            others.push(item);
          }
        }

        inOrder.sort((a, b) => a.ord - b.ord);
        sideFacetKeys = inOrder.map(e => e.item).concat(others);

        SIDE_FILTERS = sideFacetKeys
          .filter(attr => {
            const facetValues = facets[attr];
            return facetValues && Object.keys(facetValues).length > 0;
          })
          .map(attr => {
            const key = attr.split('.').pop();
            return {
              label: toTitleCase(key.replace(/_/g, ' ')),
              attribute: attr
            };
          });

        SIDE_FILTERS.forEach((filter, index) => {
          if (isSearchPage && shouldIgnoreFilter(filter.attribute)) return;

          createSideFilter(filter, index)
        });
      })
      .catch(console.error);
  }else {
    SIDE_FILTERS = Object.entries(activeSideFilters || {}).flatMap(([key, label]) => {
      const attr = key.toLowerCase();
      console.log("attr: ", attr);
      if (attr === 'color') {
        return [
          { label, attribute: 'options.color' }
        ];
      } else {
        return [{ label, attribute: `meta.custom.algolia_filters.${key}` }];
      }
    });

    SIDE_FILTERS.forEach((filter, index) => createSideFilter(filter, index));

    if(SIDE_FILTERS.length == 0){
      document.querySelector('.collection-filter') && document.querySelector('.collection-filter').classList.add('hide');
      document.querySelector('.collection-products') && document.querySelector('.collection-products').classList.add('no-padding');
      window.outerWidth < 750 && document.querySelector('.filter-trigger-warpper') && document.querySelector('.filter-trigger-warpper').classList.add('hide');
    }else{
      
      document.querySelector('.collection-filter') && document.querySelector('.collection-filter').classList.remove('hide');
      document.querySelector('.collection-products') && document.querySelector('.collection-products').classList.remove('no-padding');
      window.outerWidth == 989 && document.querySelector('.filter-trigger-warpper') && document.querySelector('.filter-trigger-warpper').classList.remove('hide');
    }

    if(window.outerWidth < 750 && TOP_FILTERS.length > 0){
      document.querySelector('.collection-filter') && document.querySelector('.collection-filter').classList.remove('hide');
      document.querySelector('.filter-trigger-warpper') && document.querySelector('.filter-trigger-warpper').classList.remove('hide');
      TOP_FILTERS.forEach((filter, index) => createSideFilter(filter, index));
    }
  }   

  function toTitleCase(str) {
   return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substring(1));
  }
  
  function createSideFilter(filter, index) {
    
    if(document.querySelector('#col_side_filter') && document.querySelector('#col_side_filter').value != ''){
      var curr_filter = filter.label.toLocaleLowerCase().replaceAll(' ','-');
      var side_filter_ignor = document.querySelector('#col_side_filter').value.toLocaleLowerCase().replaceAll(' ','-').split(',');
      if(side_filter_ignor.includes(curr_filter)){
        return;
      }
    }
    const wrapper = document.createElement('details');
    wrapper.className = 'disclosure-has-popup facets__filter-dropdown facets__disclosure js-filter';
    wrapper.id = `Details-sidefilter-${index}`;
    wrapper.setAttribute('data-index', index);
  
    wrapper.innerHTML = `
      <summary class="facets__summary focus-inset" role="button" aria-expanded="false" aria-controls="Facet-${index}">
        <div class="facets__summary-inner">
          <div class="facets__summary-title re-le-sp-2 font-blod">${filter.label}</div>
          <div class="facets__summary-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="icon icon-arrow-down">
              <path d="M13.1016 5.5L8.10156 10.5L3.10156 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </div>
        </div>
      </summary>
      <div id="Facet-${index}" class="facets__display">
        <ul class="facets__list list-unstyled" role="list" id="side-facet-list-${index}"></ul>
      </div>
    `;
  
    sideFilterWrapper.appendChild(wrapper);
  
    search.addWidgets([
      instantsearch.connectors.connectRefinementList((renderOptions, isFirstRender) => {
        const { items, refine } = renderOptions;
        const ul = document.getElementById(`side-facet-list-${index}`);
        ul.innerHTML = '';

        const sortedItems = [...items].sort((a, b) =>
          a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' })
        );
  
        sortedItems.forEach(item => {
          const li = document.createElement('li');
          li.className = 'list-menu__item facets__item field--checkbox';
          const id = `Filter-${index}-${item.label.replace(/\s+/g, '-')}`;
  
          let label = item.label;          
          if ( filter.label == "Direct Burial" || filter.label == "Rohs Compliant" || filter.label == "Plenum Rating" || filter.label == "Riser Rating" ){
            label = label == "false" ? "No": label;
            label = label == "true" ? "Yes": label;
          }
          li.innerHTML = `
            <input type="checkbox" class="focus-inset" value="${item.value}" id="${id}" ${item.isRefined ? 'checked' : ''}>
            <label for="${id}" class="facet-checkbox re-le-sp-1">
              <span class="icon icon-checkmark"></span>
              <span class="facet-checkbox__label">${label}</span>
            </label>
          `;
  
          li.querySelector('input').addEventListener('change', () => {
            refine(item.value);
            // Update UI after checkbox change
            // updateFilterUI(wrapper, filter.attribute); // Removed this line
          });
  
          ul.appendChild(li);
        });

        if(items.length == 0){
          wrapper.classList.add('hidden');
        }else{
          wrapper.classList.remove('hidden');
        }

        // Initial UI update
        if (!isFirstRender) {
          //updateFilterUI(wrapper, filter.attribute);
        }

      })({
        container: `#side-facet-list-${index}`,
        attribute: filter.attribute,
        limit: 100
      })
    ]);
  }
  
  
  // Custom Hits Widget
  const customHits = instantsearch.connectors.connectHits(function renderGroupedHits(params, isFirstRender) {
    const { hits, widgetParams } = params;
  
    const groupedProducts = generateGroupedProductsJSON(hits);
    const container = widgetParams.container;
    container.innerHTML = '<table class="coll-pro-color-table test2" data-table-grid-option="1"><tbody>';
  
    groupedProducts.forEach(group => {


      const table_tr_stucture = document.createElement('tr');
      table_tr_stucture.className = 'coll-pro-cota-tr';
      const table_td_stucture = document.createElement('td');
      table_td_stucture.className = 'cota-td-item cota-td-img-title';
      const heading = document.createElement('h2');
      heading.className = 'group-heading pro-title-cota re-le-sp-2 h-m-tb';
      heading.textContent = group.group_heading;
      if(group.group_image != '' && group.group_image != undefined){
        const img_html = document.createElement('div');
        img_html.className = 'pro-image-cota';
        img_html.innerHTML = group.group_image;
        table_td_stucture.appendChild(img_html);
      }
      
      table_td_stucture.appendChild(heading);
      table_tr_stucture.appendChild(table_td_stucture);
      
      // console.log(get_template_prefix,'get_template_prefix');

      if(document.querySelector("#col_meta")?.value != 'undefined' && document.querySelector("#col_meta")?.value != '') {
        var title_data = '';
        if(document.querySelector('#col_show_group').value != ''){
          var display_titles = '';
          var display_colum_value = document.querySelector('#col_show_group').value.split(',');
          var table_header = display_titles.split(',');
          display_colum_value.forEach((table_title)=>{
            table_title = table_title.split(':')[0]
            if(title_data == ''){
              title_data = '<th class="re-le-sp-1">'+table_title+'</th>';
            }else{
              title_data += '<th class="re-le-sp-1">'+table_title+'</th>';
            }
          })
        }

        if(group.products.length > 0){
          var tableHTML = `
            <td><table class="coll-pro-table test1" data-table-grid-option="1">        
              <thead class="small-hide">
                <tr class="coll-pro-ta-head"> 
                  ${title_data}
                  <th class="th-price re-le-sp-1">Price</th>
                </tr>
              </thead>
              <tbody>
                ${group.products.map(product => {
                  //console.log(product,'product.meta_value');
                  var display_colum_value = document.querySelector('#col_show_group').value.split(',');
                  var value_data = '';
                  if(display_colum_value != ''){
                    display_colum_value.forEach((table_value,index)=>{
                      table_value = table_value.split(':');
                      const t_value_0 = table_value[0];
                       
                      // if(table_value[1] == 'awg_size'){
                      //   value_data += `<td class="td-item"><a href="/products/${product.handle}" class="prpduct-title font-blod re-le-sp-2">${product.meta_value[table_value[1]]}</a></td>`;

                      // }else if(product.meta_value[table_value[1]] != undefined){
                      if(product.meta_value[table_value[1]] != undefined){
                        var value = product.meta_value[table_value[1]];
                        if ( t_value_0 == "Direct Burial" || t_value_0 == "Rohs Compliant" || t_value_0 == "Plenum Rating" || t_value_0 == "Riser Rating" ){                          
                          value = value.toString()
                          value = value.indexOf('true') > -1 ? value.replace('true','Yes'): value.replace('false','No');
                        }
                        if(index == 0){
                          value_data += `<td class="td-item td-text" data-title="${t_value_0}"><a href="${productUrl(product.handle)}" class="prpduct-title font-blod re-le-sp-2">${value}</a></td>`;
                        }else{
                          value_data += `<td class="td-item td-text" data-title="${t_value_0}">${value}</td>`;
                        }
                        
                      }else{
                        value_data += `<td class="td-item td-text"></td>`;
                      }
                    })
                  }

                  var price_meta = '';
                  if(product.metafields.Content != undefined){
                    price_meta = product.metafields.Content.Shortdescription;
                    if(price_meta.indexOf('Sold by') != -1){
                      var temp_price_meta = price_meta.split('Sold by')[1];
                      price_meta = `<span class="pro-sold-by re-le-sp-1">Sold by${temp_price_meta}</span>`;
                    }else{
                      price_meta = '';
                    }
                  }else{
                    price_meta = '';
                  }
                  
                  if(product.tags.includes('multi-value') && product.price_min < product.price_max){
                    var from_html = `<span class="from">From </span>`;
                  }else{
                    var from_html = ``;
                  }

                  // if(product.variant_title.indexOf('Spool') > -1 && product.metafields.Content == undefined && product.tags.includes('multi-value')){
                  //   var set_price = product.price;
                  //   var store_split = product.variant_title.split('/');
                  //   if(store_split[0].indexOf('Spool') > -1){
                  //     set_price = Number(Number(set_price/Number(store_split[0].split('ft')[0].trim())).toFixed(2));
                  //   }else{
                  //     set_price = Number(Number(set_price/Number(store_split[1].split('ft')[0].trim())).toFixed(2));
                  //   }
                  // }else{
                  //   var set_price = product.price;
                  // }
                  var set_price = product.price;


                  // var unit_value = 'ft';
                  // if(product.metafields.custom.unit){
                  //   unit_value = product.metafields.custom.unit;
                  // }
                  var unit_value = 'ea.';
                  var vari_title = product.variant_title.toLowerCase();
                  if(product.metafields.custom.unit){
                    unit_value = product.metafields.custom.unit;
                  }
                  if(vari_title.indexOf('by the foot') > -1){
                    var unit_value = 'ft.';
                  }
                  var picked = pickDisplayVariant(product.variant_array);
                  if(picked){
                    set_price = (Number(product.price_min) > 0) ? product.price_min : ((Number(product.price) > 0) ? product.price : set_price);
                    // Only take the variant's unit when the price on screen IS that variant's
                    // price. The variant list can be stale (e.g. it still lists a "By the Foot"
                    // variant the product no longer has), which would label a spool price /ft.
                    if(picked.unit && samePrice(set_price, picked.price)) unit_value = picked.unit;
                    else if(looksPerFoot(set_price, product.variant_array, product.price, vari_title)) unit_value = 'ft.';
                  }
                  var price_html = `<div class="product-price font-blod re-le-sp-1">
                    ${from_html}${formatPrice(set_price)}/${unit_value}
                  </div>${price_meta}
                  `;
                  if(product.tags.includes('quote') || !(Number(set_price) > 0)){
                    price_html = `<div class="product-price font-blod re-le-sp-1 no-price"><a href="tel:18332688644">Call for Price</a></div>`;
                  }
                return `
                  <tr class="coll-pro-ta-tr">
                    ${value_data}
                    <td class="td-item td-price">${price_html}</td>
                  </tr>
                `}).join('')}
              </tbody>
            </table></td>
          `
        }else{
          var tableHTML = `<td><div class="collection-empty">
            <div class="wrapper center">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-search coll-empty-icon" width="25" height="24" viewBox="0 0 25 24" fill="none">
                  <path d="M9.83203 18C14.2503 18 17.832 14.4183 17.832 10C17.832 5.58172 14.2503 2 9.83203 2C5.41375 2 1.83203 5.58172 1.83203 10C1.83203 14.4183 5.41375 18 9.83203 18Z" stroke="currentColor" stroke-opacity="0.6" stroke-width="1.5" stroke-miterlimit="10"></path>
                  <path d="M21.8346 22L15.168 15.3334" stroke="currentColor" stroke-opacity="0.6" stroke-width="1.5" stroke-miterlimit="10"></path>
                </svg>
                <h4 class="coll-empty-title re-le-sp-2">No products found in this group.</h4>
                <div class="coll-empty-rte rte re-le-sp-1"><p>Clear your filters and start again</p></div>
            </div>
          </div></td>`;
          var tableHTML = ``;
          // table_tr_stucture.classList.add('hidden');
          table_tr_stucture.innerHTML = '';
        }
      }else{
        if(group.products.length > 0){
          var tableHTML = `
            <td><table class="coll-pro-table test1" data-table-grid-option="1">        
              <thead class="small-hide">
                <tr class="coll-pro-ta-head">
                  <th class="col-1 re-le-sp-1">Product</th>
                  <th class="col-2 re-le-sp-1">Price</th>
                </tr>
              </thead>
              <tbody>
                ${group.products.map(product => {
                  var price_meta = '';
                  if(product.metafields.Content != undefined){
                    price_meta = product.metafields.Content.Shortdescription;
                    if(price_meta.indexOf('Sold by') != -1){
                      var temp_price_meta = price_meta.split('Sold by')[1];
                      price_meta = `<span class="pro-sold-by re-le-sp-1">Sold by${temp_price_meta}</span>`;
                    }else{
                      price_meta = '';
                    }
                  }else{
                    price_meta = '';
                  }

                  if(product.tags.includes('multi-value')){
                    var from_html = `<span class="from">From </span>`;
                  }else{
                    var from_html = ``;
                  }
                  // var unit_value = 'ea.';
                  // // var unit_value = 'ft';
                  // if(product.metafields.custom.unit){
                  //   unit_value = product.metafields.custom.unit;
                  // }

                  var set_price = product.price;
                  // if(product.variant_title.indexOf('Spool') > -1 && product.tags.includes('multi-value')){
                  //   var set_price = product.price;
                  //   var store_split = product.variant_title.split('/');
                  //   if(store_split[0].indexOf('Spool') > -1){
                  //     set_price = Number(Number(set_price/Number(store_split[0].split('ft')[0].trim())).toFixed(2));
                  //   }else{
                  //     set_price = Number(Number(set_price/Number(store_split[1].split('ft')[0].trim())).toFixed(2));
                  //   }
                  // }else{
                  //   var set_price = product.price;
                  // }
                  var unit_value = 'ea.';
                  var vari_title = product.variant_title.toLowerCase();
                  if(product.metafields.custom.unit){
                    unit_value = product.metafields.custom.unit;
                  }
                  if(vari_title.indexOf('by the foot') > -1){
                    var unit_value = 'ft.';
                  }
                  var picked = pickDisplayVariant(product.variant_array);
                  if(picked){
                    set_price = (Number(product.price_min) > 0) ? product.price_min : ((Number(product.price) > 0) ? product.price : set_price);
                    // Only take the variant's unit when the price on screen IS that variant's
                    // price. The variant list can be stale (e.g. it still lists a "By the Foot"
                    // variant the product no longer has), which would label a spool price /ft.
                    if(picked.unit && samePrice(set_price, picked.price)) unit_value = picked.unit;
                    else if(looksPerFoot(set_price, product.variant_array, product.price, vari_title)) unit_value = 'ft.';
                  }

                  var price_html = `<div class="product-price font-blod re-le-sp-1">
                    ${from_html}${formatPrice(set_price)}${unit_value}
                  </div>
                  ${price_meta}`;
                  if(product.tags.includes('quote') || !(Number(set_price) > 0)){
                    price_html = `<div class="product-price font-blod re-le-sp-1 no-price"><a href="tel:18332688644">Call for Price</a></div>`;
                  }
                return `
                  <tr class="coll-pro-ta-tr">            
                    <td class="td-item td-img-title">
                      <div class="product-image">
                        <img src="${product.image}" alt="${product.title}" loading="lazy" width="60" height="60">
                      </div>
                      <a href="${productUrl(product.handle)}" class="prpduct-title font-blod re-le-sp-2">
                        ${product.title}
                      </a>
                    </td>
                    <td class="td-item td-price">${price_html}</td>
                  </tr>
                `}).join('')}
              </tbody>
            </table></td>
          `
        }else{
          var tableHTML = `<td><div class="collection-empty">
            <div class="wrapper center">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-search coll-empty-icon" width="25" height="24" viewBox="0 0 25 24" fill="none">
                  <path d="M9.83203 18C14.2503 18 17.832 14.4183 17.832 10C17.832 5.58172 14.2503 2 9.83203 2C5.41375 2 1.83203 5.58172 1.83203 10C1.83203 14.4183 5.41375 18 9.83203 18Z" stroke="currentColor" stroke-opacity="0.6" stroke-width="1.5" stroke-miterlimit="10"></path>
                  <path d="M21.8346 22L15.168 15.3334" stroke="currentColor" stroke-opacity="0.6" stroke-width="1.5" stroke-miterlimit="10"></path>
                </svg>
                <h4 class="coll-empty-title re-le-sp-2">No products found in this group.</h4>
                <div class="coll-empty-rte rte re-le-sp-1"><p>Clear your filters and start again</p></div>
            </div>
          </div></td>`;
          var tableHTML = ``;
          // table_tr_stucture.classList.add('hidden');
          table_tr_stucture.innerHTML = '';
        }
      }

      table_tr_stucture.innerHTML += tableHTML;
  
      if(table_tr_stucture.innerHTML != ''){
        container.querySelector('.coll-pro-color-table tbody').appendChild(table_tr_stucture);
      }
      
      
  
      //container.insertAdjacentHTML('beforeend', tableHTML);
    });

    container.innerHTML += '</tbody></table>';

    if(groupedProducts.length == 0){
      
      var tableHTML = `<table class="coll-pro-table" data-table-grid-option="1">        
          <thead class="small-hide">
            <tr class="coll-pro-ta-head">
              <th class="col-1 re-le-sp-1">Product</th>
              <th class="col-2 re-le-sp-1">Price</th>
            </tr>
          </thead>
          <tbody>
          ${hits.map(product => {
            var prod_img = product.image;
            if(product.image == null){
              prod_img = 'https://cdn.shopify.com/s/files/1/0663/2649/5289/files/Frame_6466.png?v=1748520880';
            }
            var price_meta = '';
            if(product.metafields && product.metafields.Content != undefined){
              price_meta = product.metafields.Content.Shortdescription;
              if(price_meta.indexOf('Sold by') != -1){
                var temp_price_meta = price_meta.split('Sold by')[1];
                price_meta = `<span class="pro-sold-by re-le-sp-1">Sold by${temp_price_meta}</span>`;
              }else{
                price_meta = '';
              }
            }else{
              price_meta = '';
            }

            if(product.tags.includes('multi-value')){
              var from_html = `<span class="from">From </span>`;
            }else{
              var from_html = ``;
            }
            // var unit_value = 'ea.';
            // // var unit_value = 'ft';
            // if(product.meta.custom.unit){
            //   unit_value = product.meta.custom.unit;
            // }

            var set_price = product.variants_min_price;
            // if(product.variant_title.indexOf('Spool') > -1 && product.tags.includes('multi-value')){
            //   var set_price = product.variants_min_price;
            //   var store_split = product.variant_title.split('/');
            //   if(store_split[0].indexOf('Spool') > -1){
            //     set_price = Number(Number(set_price/Number(store_split[0].split('ft')[0].trim())).toFixed(2));
            //   }else{
            //     set_price = Number(Number(set_price/Number(store_split[1].split('ft')[0].trim())).toFixed(2));
            //   }
            // }else{
            //   var set_price = product.variants_min_price;
            // }
            var unit_value = 'ea.';
            var vari_title = product.variant_title.toLowerCase();
            if(product.meta.custom.unit){
              unit_value = product.meta.custom.unit;
            }
            if(vari_title.indexOf('by the foot') > -1){
              var unit_value = 'ft.';
            }
            var picked = pickDisplayVariant(product.meta.custom.product_variants);
            if(picked){
              set_price = (Number(product.variants_min_price) > 0) ? product.variants_min_price : ((Number(product.price) > 0) ? product.price : set_price);
              // See note above: the unit only applies when the displayed price is that
              // variant's price, otherwise a stale variant list mislabels the unit.
              if(picked.unit && samePrice(set_price, picked.price)) unit_value = picked.unit;
              else if(looksPerFoot(set_price, product.meta.custom.product_variants, product.price, vari_title)) unit_value = 'ft.';
            }

            var price_html = `<div class="product-price font-blod re-le-sp-1">
                  ${from_html}${formatPrice(set_price)}/${unit_value}
                </div>
              ${price_meta}`;
            if(product.tags.includes('quote')){
              price_html = `<div class="product-price font-blod re-le-sp-1 no-price"><a href="tel:18332688644">Call for Price</a></div>`;
            }
            return `
            <tr class="coll-pro-ta-tr">            
              <td class="td-item td-img-title">
                <div class="product-image">
                  <img src="${prod_img}" alt="${product.title}" loading="lazy" width="60" height="60">
                </div>
                <a href="${productUrl(product.handle)}" class="prpduct-title font-blod re-le-sp-2">
                  ${product.title}
                </a>
              </td>
              <td class="td-item td-price">
                ${price_html}
              </td>
            </tr>
          `}).join('')}
        </tbody>
      </table>`
      container.insertAdjacentHTML('beforeend', tableHTML);
    }    
    
    container.querySelectorAll('.coll-pro-cota-tr').forEach((tr_ele)=>{
      const td_length = tr_ele.querySelectorAll('.coll-pro-ta-tr')[0].querySelectorAll('td').length;        
        if( td_length > 3 ){
          tr_ele.querySelector('table').classList.add('centerNot_fristLast');
        }      
    });
  });
  
  const selectedFiltersContainer = document.querySelector('.coll-current_filter-group');
  const productCountContainer = document.querySelector('.product-count');
  
  function shouldIgnoreFilter(attr) {
    if (!isSearchPage) return false;
    const key = attr.split('.').pop(); // Extract `color` from `meta.custom.algolia_filters.color`
    return searchPageFilterIgnore.includes(key.toLowerCase());
  }

  function renderSelectedFilters() {
    const refinements = search.helper.state.disjunctiveFacetsRefinements;
    selectedFiltersContainer.innerHTML = '';
  
    Object.keys(refinements).forEach(attribute => {
      refinements[attribute].forEach(value => {
        let temp_name = getFilterLabelFromAttribute(attribute);
        const name = temp_name.indexOf('_') > -1 ? temp_name.split('_').join(' '): temp_name;
        let temp_value = value;
        if ( name == "direct_burial" || name == "direct burial" || name == "rohs compliant" ){
          temp_value = temp_value == "false" ? "No": temp_value;
          temp_value = temp_value == "true" ? "Yes": temp_value;
        }

        const div = document.createElement('div');
        div.className = 'current_filter re-le-sp-1';
        div.innerHTML = `
          <span class="font-blod">${name}:</span>
          <span>${temp_value}</span>
          <span class="remove-filter" data-attribute="${attribute}" data-value="${value}">
            ✕
          </span>
        `;
        selectedFiltersContainer.appendChild(div);
      });
    });
  
    // console.log(selectedFiltersContainer.children.length,'len');
    if (selectedFiltersContainer.children.length > 0) {
      const clearAll = document.createElement('span');
      clearAll.className = 'clear-all font-blod re-le-sp-1';
      clearAll.innerHTML = `Clear all <span class="remove-all">✕</span>`;
      selectedFiltersContainer.appendChild(clearAll);
  
      clearAll.addEventListener('click', () => {
        search.helper.clearRefinements().search();
      });
    }
  
    selectedFiltersContainer.querySelectorAll('.remove-filter').forEach(el => {
      el.addEventListener('click', () => {
        const attribute = el.getAttribute('data-attribute');
        const value = el.getAttribute('data-value');
        search.helper.removeDisjunctiveFacetRefinement(attribute, value).search();
      });
    });
  }
  
  function renderProductCount(results) {
    // console.log("results.nbHits: ", results.nbHits);
    if (productCountContainer && results.nbHits !== undefined) {
      productCountContainer.textContent = `${results.nbHits} Products`;
    }
  }
  
  function getFilterLabelFromAttribute(attribute) {
    switch(attribute) {
      case 'meta.custom.algolia_filters.conductor_material': return 'Conductor Material';
      case 'meta.custom.algolia_filters.awg_size': return 'AWG Size';
      case 'meta.custom.algolia_filters.color': return 'Color';
      case 'meta.custom.algolia_filters.amps': return 'Amps';
      case 'meta.custom.algolia_filters.conductor_type': return 'Conductor Type';
      case 'meta.custom.algolia_filters.stranding': return 'Stranding';
      case 'meta.custom.algolia_filters.od': return 'OD';
      case 'meta.custom.algolia_filters.temp_rating': return 'Temp Rating';
      default: return attribute.replace("meta.custom.algolia_filters.", "").replace("options.", "");
    }
  }
  
  
  
  search.on('render', () => {
    const results = search.helper.lastResults;
    const currentQuery = search.helper.state.query || '';
    qsClient
    .search(currentQuery, { hitsPerPage: 1 })
    .then(({ hits }) => {
      if (
        hits.length > 0 &&
        hits[0].query.toLowerCase() !== currentQuery.toLowerCase()
      ) {
        const suggestion = hits[0].query;
        if(suggestionContainer){
          suggestionContainer.innerHTML = `
          Did you mean  
          <a href="/search?query=${suggestion}"><strong>${suggestion}</strong></a>
          `;
        }
      } else {
        if(suggestionContainer){
          suggestionContainer.textContent = ''; 
        }
      }
    })
    .catch(err => {
      if(suggestionContainer){
        suggestionContainer.textContent = '';
      }
    });
    
    if(results != null){
      if(results.hits.length == 0){
        var msg = 'No products found in this collection.';
        if(document.querySelector('#chk_template_type').value != 'collection'){
          msg = 'No products found.';
        }
        document.querySelector('.facets-top').classList.add('hidden');
        document.querySelector('.collection-main').classList.add('hide');
        if(document.querySelector('.collection-main').parentElement.querySelectorAll('.collection-empty:not(.hidden)').length == 0){
          document.querySelector('.collection-main').parentElement.innerHTML += `<div class="collection-empty">
            <div class="wrapper center">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-search coll-empty-icon" width="25" height="24" viewBox="0 0 25 24" fill="none">
                  <path d="M9.83203 18C14.2503 18 17.832 14.4183 17.832 10C17.832 5.58172 14.2503 2 9.83203 2C5.41375 2 1.83203 5.58172 1.83203 10C1.83203 14.4183 5.41375 18 9.83203 18Z" stroke="currentColor" stroke-opacity="0.6" stroke-width="1.5" stroke-miterlimit="10"></path>
                  <path d="M21.8346 22L15.168 15.3334" stroke="currentColor" stroke-opacity="0.6" stroke-width="1.5" stroke-miterlimit="10"></path>
                </svg>
                <h4 class="coll-empty-title re-le-sp-2">${msg}</h4>
            </div>
          </div>`;
        }
        
      }
    }
    
    if (results && results.nbHits !== undefined) {
      renderProductCount(results);
    }
    renderSelectedFilters();

    // Update all filter UIs
    TOP_FILTERS.forEach((filter, index) => {
      const filterContainer = document.querySelector(`#Details-top-${index}`);
      if (filterContainer) {
        updateFilterUI(filterContainer, filter.attribute);
      }
    });

    SIDE_FILTERS.forEach((filter, index) => {
      const filterContainer = document.querySelector(`#Details-sidefilter-${index}`);
      if (filterContainer) {
        //updateFilterUI(filterContainer, filter.attribute);
      }
    });

    // Check if any filters are selected globally
    const allRefinements = search.helper.state.disjunctiveFacetsRefinements;
    const hasAnyFilterSelectedGlobally = Object.keys(allRefinements).some(attribute => allRefinements[attribute]?.length > 0);

    // Find the mobile filter footer and the clear all button within it
    const mobileFilterFooter = document.querySelector('.filter-mobile-footer');
    const mobileClearAllButton = mobileFilterFooter?.querySelector('.filter-clear');

    // Show/hide the mobile clear all button based on whether any filters are selected
    if (mobileClearAllButton) {
      if (hasAnyFilterSelectedGlobally) {
        mobileClearAllButton.style.display = ''; // Show the button
      } else {
        mobileClearAllButton.style.display = 'none'; // Hide the button
      }

      // Add event listener to the mobile footer clear all button
      mobileClearAllButton.removeEventListener('click', handleMobileClearAllClick); // Remove previous listener if any
      mobileClearAllButton.addEventListener('click', handleMobileClearAllClick);
    }

    // Find the mobile filter footer and the apply button within it
    const mobileApplyButton = mobileFilterFooter?.querySelector('.filter-apply');

    // Add event listener to the mobile footer apply button
    if (mobileApplyButton) {
      mobileApplyButton.removeEventListener('click', handleMobileApplyClick); // Remove previous listener if any
      mobileApplyButton.addEventListener('click', handleMobileApplyClick);
    }
    
  });
  
  var r = "";
  var col = document.querySelector("#col_id").value;
  if(document.querySelector('#chk_template_type').value == 'collection'){
    //r = 'collections:"' + document.querySelector("#col_name").value + '"';
    if(col != "" && col != null){
      r = 'collection_ids:"' + document.querySelector("#col_id").value + '"';
    }    
  }else{
    r = document.querySelector('#chk_template_type').value;
  }
  
  search.addWidgets([
    instantsearch.widgets.configure({
      hitsPerPage: 100,
      //distinct: 1,
      filters: r,
      ruleContexts: ['merchandising']
    }),
  ]);

  // Define a pagination widget that is hidden when there is only one page
  const hiddenPagination = instantsearch.widgets.panel({
    hidden: ({ results }) => results.nbPages === 1,
  })(instantsearch.widgets.pagination);

  // Add the hidden pagination widget instance and custom hits widget

  // if(document.querySelector('#chk_template_type').value != 'collection'){
  //   search.addWidgets([
  //     searchBox({
  //       container: "#searchboxsmall",
  //       classList: "hidden",
  //       placeholder: "Search for products",
  //       queryHook(query, search) {
  //         let searching = query;
  //         if (searching !== "") {
  //           search(searching);
  //         } else {
  //           search(" ");
  //         }
  //       },
  //     }),
  //     customHits({
  //       container: document.querySelector('.algolia-fil-products')
  //     }),
  //   ]);
  // }else{
    search.addWidgets([
      hiddenPagination({
        container: '#pagination'
      }),
      customHits({
        container: document.querySelector('.algolia-fil-products')
      })
    ]);
  // }
  
  
  search.start();

  if (initialQuery) {
    search.helper.setQuery(initialQuery).search();
    document.querySelector('.collection-hero__title').innerText += ' ' + initialQuery;
    document.querySelector('.search-container .search-box form input').value = initialQuery;
  }
  
  function generateGroupedProductsJSON(hits) {
    const collectionGroupingValue = JSON.parse(document.querySelector("#col_meta")?.value || '[]');
    const collectionGroupingImgValue = document.querySelector("#col_meta_img").value.split(',');
    const collectionGroupingValues = collectionGroupingValue.map(v => v.trim()).filter(Boolean);
  
    const groupedData = {};
    const productTracker = {};
  
    collectionGroupingValues.forEach(group => {
      groupedData[group] = [];
      productTracker[group] = new Set();
    });
  
    hits.forEach(hit => {
      //console.log(hit,'hit');
      let groupingValues = [];
  
      if (hit.meta && hit.meta.custom && hit.meta.custom.grouping) {
        try {
          groupingValues = JSON.parse(hit.meta.custom.grouping);
          if (!Array.isArray(groupingValues)) {
            groupingValues = [groupingValues];
          }
        } catch (e) {
          console.warn(`Invalid JSON in grouping for product: ${hit.title}`, e);
        }
      }
  
      if (groupingValues.length === 0) return;
  
      const productId = hit.id;
  
      groupingValues.forEach(productGroupValue => {
        if (collectionGroupingValues.includes(productGroupValue)) {
          const productData = {
            title: hit.title || '',
            image: hit.image || '',
            handle: hit.handle || '',
            price: hit.price || '',
            price_min: hit.variants_min_price || '',
            price_max: hit.variants_max_price || '',
            tags: hit.tags || '',
            stock_level: getStockLevel(hit),
            vendor: hit.vendor || '',
            meta_value: hit.meta.custom.algolia_filters || '',
            metafields: hit.meta || '',
            conductor_type: '',
            od: '',
            amps: '',
            awg_size: '',
            variant_count: hit.variants_count,
            variant_title: hit.variant_title,
            variant_array: hit.meta.custom.product_variants,
          };
  
          if (!productTracker[productGroupValue].has(productId)) {
            groupedData[productGroupValue].push(productData);
            productTracker[productGroupValue].add(productId);
          }
        }
      });
    });
  
    return collectionGroupingValues.map((group,index) => ({
      group_heading: group,
      group_image: collectionGroupingImgValue[index],
      products: groupedData[group] || []
    }));
  }
  
  function getStockLevel(hit) {
    if (hit.variants_inventory_count === 0) {
      return 'Out of Stock';
    } else if (hit.variants_inventory_count > 0 && hit.variants_inventory_count <= 5) {
      return 'Low Stock';
    } else {
      return 'In Stock';
    }
  }
  
  function getStockLabelClass(stockLevel) {
    switch (stockLevel.toLowerCase()) {
      case 'low stock':
        return 'low-stock';
      case 'out of stock':
        return 'out-stock';
      default:
        return 'in-stock';
    }
  }
  
  function formatPrice(price) {
    if (typeof price === 'number') {
      return `$${price.toFixed(2)}`;
    }
    return price || '';
  }

  // True when two prices are the same amount (cent tolerance, string or number).
  // custom.product_variants can hold old prices, so samePrice() misses a current per-foot price
  // (12 AWG THHN showed $0.41/ea.). A per-foot price is always far below the cheapest spool.
  // The stored list can also hold $0.00 spools (products that used to be quote-only), so the
  // matched record's own spool price is used as a reference too.
  function looksPerFoot(price, variantArray, hitPrice, hitTitle) {
    const p = Number(price);
    if (!(p > 0)) return false;
    const spools = (Array.isArray(variantArray) ? variantArray : [])
      .filter(v => (v.title || '').toLowerCase().indexOf('by the foot') === -1)
      .map(v => parseFloat(v.price))
      .filter(n => n > 0);
    const hp = Number(hitPrice);
    if (hp > 0 && String(hitTitle || '').toLowerCase().indexOf('by the foot') === -1) spools.push(hp);
    if (!spools.length) return false;
    return p < Math.min.apply(null, spools) * 0.2;
  }

  function samePrice(a, b) {
    const x = Number(a), y = Number(b);
    if (!isFinite(x) || !isFinite(y)) return false;
    return Math.abs(x - y) < 0.005;
  }

  function pickDisplayVariant(variantArray) {
    if (!Array.isArray(variantArray) || variantArray.length === 0) return null;

    const foot = variantArray.find(v =>
      (v.title || '').toLowerCase().indexOf('by the foot') > -1
    );
    if (foot) {
      return { price: parseFloat(foot.price), title: foot.title, unit: 'ft.' };
    }

    let lowest = null;
    for (const v of variantArray) {
      const p = parseFloat(v.price);
      if (isNaN(p)) continue;
      if (lowest === null || p < lowest.price) lowest = { price: p, title: v.title };
    }
    if (!lowest) return null;

    return { price: lowest.price, title: lowest.title, unit: null };
  }

// Define the event handler function
function handleMobileClearAllClick() {
  search.helper.clearRefinements().search();
  // Close the mobile filter drawer
  document.body.classList.remove('show-coll-filter');
}

// Define the event handler function for the mobile apply button
function handleMobileApplyClick() {
  // Close the mobile filter drawer
  document.body.classList.remove('show-coll-filter');
}